import type { TPageTranslations } from '@crehana/i18n';

import { PAGE_KEY } from './constants';
import type { TKeys } from './types';

export const en: TPageTranslations<TKeys, typeof PAGE_KEY> = {
  [PAGE_KEY]: {
    SEO_PAGE_TITLE: 'Hours Calculation | Attendance | Crehana',
    SEO_PAGE_DESCRIPTION:
      'View overtime and late hours calculations from attendance records.',
    BREADCRUMB_HOME: 'Home',
    BREADCRUMB_ATTENDANCE: 'Attendance',
    BREADCRUMB_HOURS_CALCULATION: 'Hours calculation',
    PAGE_TITLE: 'Hours calculation',
    PAGE_DESCRIPTION:
      'View overtime and late hours calculations from your team attendance records',
    CTA_DOWNLOAD_REPORT: 'Download report',
    DOWNLOAD_COMING_SOON: 'Coming soon',
    FILTER_PERIOD_LABEL: 'Period:',
    FILTER_DATE_SEPARATOR: 'to',
    FILTER_BUTTON: 'Filter',
    CARD_TOTAL_COLLABORATORS: 'Total collaborators',
    CARD_TOTAL_COLLABORATORS_SUB: 'With records in the period',
    CARD_OVERTIME_HOURS: 'Accumulated overtime',
    CARD_LATE_HOURS: 'Late hours',
    CARD_TEAM_TOTAL: 'Team total',
    TABLE_TITLE: 'Summary per collaborator',
    SEARCH_PLACEHOLDER: 'Search collaborator...',
    COLUMN_COLLABORATOR: 'Collaborator',
    COLUMN_SHIFT: 'Assigned shift',
    COLUMN_WORKED_HOURS: 'Worked hours',
    COLUMN_OVERTIME: 'Overtime',
    COLUMN_LATE_HOURS: 'Late hours',
    DAILY_BREAKDOWN_TITLE: 'Daily breakdown',
    DETAIL_COL_DATE: 'Day',
    DETAIL_COL_PLANNED_HOURS: 'Planned hours',
    DETAIL_COL_WORKED_HOURS: 'Worked hours',
    DETAIL_COL_OVERTIME: 'Overtime',
    DETAIL_COL_LATE_HOURS: 'Late hours',
    DETAIL_ACTION_REVIEW: 'Review',
    EMPTY_NO_DATA: 'No attendance records found for the selected period.',
    EMPTY_NO_DATA_DESCRIPTION:
      'Select a different period or verify that collaborators have records.',
    FILTER_RANGE_DAYS: '({{count}} days)',

    // table root states messages
    TABLE_STATE_ERROR_TITLE: 'Error loading data',
    TABLE_STATE_ERROR_SUBTITLE:
      'An error occurred while loading the information. Please try again.',
    TABLE_STATE_ERROR_RETRY: 'Retry',
    TABLE_STATE_EMPTY_SEARCH_TITLE: 'No results found',
    TABLE_STATE_EMPTY_SEARCH_SUBTITLE:
      'No records found that match "{{query}}".',
    TABLE_STATE_EMPTY_NO_DATA_TITLE: 'No data available',
    TABLE_STATE_EMPTY_NO_DATA_SUBTITLE: 'No data available',
    TABLE_STATE_EMPTY_NO_DATA_CTA: 'Create record',

    // Day records dialog
    RECORDS_DIALOG_TITLE: 'Daily records',
    RECORDS_DIALOG_CLOSE: 'Close',
    RECORDS_DIALOG_VIEW_ALL: 'View all records',
    RECORDS_COL_TIME: 'Time',
    RECORDS_COL_EVENT: 'Event',
    RECORDS_COL_STATUS: 'Status',
    RECORDS_COL_LOCATION: 'Location',
    RECORDS_COL_CLOCK_TYPE: 'Clock type',
    RECORDS_ESTIMATED: 'Expected: {{time}}',
    RECORDS_EVENT_ENTRY: 'Entry',
    RECORDS_EVENT_BREAK_START: 'Break start',
    RECORDS_EVENT_BREAK_END: 'Break end',
    RECORDS_EVENT_EXIT: 'Exit',
    RECORDS_STATUS_ON_TIME: 'On time',
    RECORDS_STATUS_ACCEPTABLE: 'Acceptable',
    RECORDS_STATUS_LATE_OR_ABSENT: 'Late or absent',
    RECORDS_CLOCK_WEB: 'Web',
    RECORDS_CLOCK_QR_TABLET: 'QR Tablet',
    RECORDS_CLOCK_APP_MOBILE: 'Mobile App',
    RECORDS_CLOCK_BIOMETRIC: 'Biometric',

    EMPLOYEE_DIALOG_DETAIL_RECORDS_EDIT_RECORD: 'Edit record',
  },
};
